import { render, staticRenderFns } from "./UpdateProject.vue?vue&type=template&id=aeea43e2&"
import script from "./UpdateProject.vue?vue&type=script&lang=js&"
export * from "./UpdateProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports